import { useT } from '../../i18n/LocaleContext'
import { Chip, RangeSlider, SplitSlider } from './fields'
import { ZONES, type DevisAnswers, type Zone } from './types'

export default function StepVolumes({
  answers,
  update,
}: {
  answers: DevisAnswers
  update: (patch: Partial<DevisAnswers>) => void
}) {
  const { t } = useT()

  const toggleZone = (z: Zone) =>
    update({ zones: answers.zones.includes(z) ? answers.zones.filter((x) => x !== z) : [...answers.zones, z] })

  const unit = (key: string) => <span className="text-base font-medium text-ink-500">{t('devisWizard.units.' + key)}</span>

  return (
    <div className="space-y-8">
      <h3 className="text-lg font-semibold tracking-tight text-ink-950">{t('devisWizard.step2.title')}</h3>

      <RangeSlider
        label={t('devisWizard.step2.ordersLabel')}
        min={100}
        max={5000}
        step={50}
        value={answers.ordersPerMonth}
        onChange={(v) => update({ ordersPerMonth: v })}
        format={(v, atMax) => (
          <>
            {v}
            {atMax ? '+' : ''} {unit('orders')}
          </>
        )}
      />

      <RangeSlider
        label={t('devisWizard.step2.itemsLabel')}
        min={1}
        max={20}
        step={1}
        value={answers.itemsPerParcel}
        onChange={(v) => update({ itemsPerParcel: v })}
        format={(v, atMax) => (
          <>
            {v}
            {atMax ? '+' : ''} {unit('items')}
          </>
        )}
      />

      <RangeSlider
        label={t('devisWizard.step2.weightLabel')}
        min={20}
        max={5000}
        step={10}
        value={answers.weightPerItem}
        onChange={(v) => update({ weightPerItem: v })}
        format={(v, atMax) => (
          <>
            {v}
            {atMax ? '+' : ''} {unit('weight')}
          </>
        )}
      />

      <SplitSlider
        label={t('devisWizard.step2.splitLabel')}
        value={answers.homeDeliveryPct}
        onChange={(v) => update({ homeDeliveryPct: v })}
        leftLabel={t('devisWizard.step2.splitHome')}
        rightLabel={t('devisWizard.step2.splitPickup')}
      />

      <div>
        <p className="mb-3 text-xs font-semibold text-ink-800">{t('devisWizard.step2.zonesLabel')}</p>
        <div className="flex flex-wrap gap-2.5">
          {ZONES.map((z) => (
            <Chip
              key={z}
              label={t('devisWizard.zones.' + z)}
              selected={answers.zones.includes(z)}
              onClick={() => toggleZone(z)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
